import { createAction } from 'redux-starter-kit';
import { post } from '../../../../utility/via-fetch';
import { putUser } from '../../../domain/users/userActions';
import { requestStart, requestSucceded, requestFailed } from '../../../domain/requests/RequestActions';
import { setSessionUser } from '../../application/sessionUiActions';
import { addMessage } from '../../application/messageUiActions';


/**
 * An action that signifies a request to register a user has been made.
 * @param {string} requestId The id of the request.
 * @example dispatch(fetchAuthenticateUser(requestId))
 */
export const registerUser = createAction('REGISTER_USER');

/**
 * An action that makes an authorising request to the server.
 * @param {string} username The username representing a user.
 * @param {string} password The password that will authorise access to the user.
 * @param {string} displayName The users public facing name.
 * @param {string} locale The locale code the user selected, will be the users and the companies default locale.
 * @param {string} reCaptcha The recaptcha token generated by the user's recaptcha challenge. Server uses this to verify the user isnt a bot.
 * @example dispatch(requestAuthenticateUser(username, password));
 */
export function requestRegisterUser(username, password, displayName, locale, reCaptcha) {
  return async (dispatch) => {
    const requestId = dispatch(requestStart(registerUser.toString()));
    dispatch(registerUser(requestId));

    try {
      const user = await post('/api/user-groups', undefined, {
        username,
        password,
        displayName,
        locale,
        reCaptcha,
      });
      dispatch(putUser(user)); // Update the users domain with our new user.
      dispatch(setSessionUser(user.userId)); // Update the session state with the user identifier.
      dispatch(requestSucceded(requestId)); // Update request with the payload.
      dispatch(addMessage('success', 'sessionStarted'));
    } catch (error) {
      dispatch(requestFailed(requestId, error));
    }
  };
}
